import { styled } from '@mui/material/styles';

export const StyledLogoDesktop = styled('img')`
  height: 90px;
  width: auto;
  object-fit: contain;
  cursor: pointer;
`;

export const StyledLogoMobile = styled('img')`
  width: 8%;
  height: auto;
  margin-top: 1%;
`;
